module.exports = {
  RETRIEVE_OPERATOR_USER_REQUEST: 'RETRIEVE_OPERATOR_USER_REQUEST',
  RETRIEVE_OPERATOR_USER_SUCCESS: 'RETRIEVE_OPERATOR_USER_SUCCESS',
  RETRIEVE_OPERATOR_USER_FAILURE: 'RETRIEVE_OPERATOR_USER_FAILURE',
  OPERATOR_USER_CHECKED: 'OPERATOR_USER_CHECKED',
  OPERATOR_USER_EXPANDED: 'OPERATOR_USER_EXPANDED',
  SELECT_ALL_OPERATOR_USER: 'SELECT_ALL_OPERATOR_USER',
  DESELECT_ALL_OPERATOR_USER: 'DESELECT_ALL_OPERATOR_USER',
};
